/**
 * Labstep
 *
 * @module components/ExperimentWorkflow/Timeline/Modal
 * @desc Create modal for experiment workflow from the timeline
 */

import ExperimentWorkflowFormCreate from 'labstep-web/components/ExperimentWorkflow/Form/Create';
import { ModalDefaultContainer as ModalDefault } from 'labstep-web/core/Modal/Default';
import { ExperimentWorkflow } from 'labstep-web/models/experiment-workflow.model';
import type React from 'react';
import type { IExperimentWorkflowTimelineModalProps } from './types';

export const ExperimentWorkflowTimelineModal: React.FC<
  IExperimentWorkflowTimelineModalProps
> = ({ defaultValues, onClose, options, body }) => (
  <ModalDefault
    header={`New ${ExperimentWorkflow.getHumanReadableEntityName(
      false,
      true,
    )}`}
    open
    onClose={onClose}
    viewComponent={null}
    content={() => (
      <ExperimentWorkflowFormCreate
        defaultValues={defaultValues}
        options={options}
        body={body}
      />
    )}
  />
);
